export default __webpack_public_path__ + "static/media/510df08255a6921b.86b4f456c76569c6fd4f1089bcd279c6.svg";